import { Avatar } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { chipColorStyle } from 'src/Entities/RiskTypes'
import { formatDate } from 'src/lib/utils'

export default function PeriodicityRiskComponent ({ type, data }) {
    const [ riskData, setriskData ] = useState({})
    useEffect(() => {
        setriskData(data)
    }, [data])
    return (
        <>
            <div className='p-7 flex flex-col gap-[25px]'>
                <div className='flex flex-col gap-[10px]'>
                    <p className='risk-content-title !text-subHeading-2 ' style={{ margin: 0 }}>{type === 'ISSUE' ? 'Issue Scoring' : 'Risk Scoring'}</p>
                    <div className='flex justify-between'>
                        <div className='flex gap-[10px] items-center'>
                            <div className='text-subHeading-2 text-[hsl(var(--Extreme))]'>{type === 'ISSUE' ? 'Priority' : 'Impact'} </div>
                            <div className='text-b5 text-muted' >{riskData?.impact}</div>
                        </div>
                        <div className='flex gap-[10px] items-center'>
                            <div className='text-subHeading-2 text-[hsl(var(--Controlled))]'>{type === 'ISSUE' ? 'Severity' : 'Probability'} </div>
                            <div className='text-b5 text-muted' >{riskData?.probability}</div>
                        </div>
                        <div className='flex gap-[10px] items-center'>
                            <div className='text-subHeading-2 text-primary'>{type === 'ISSUE' ? 'Issue Level' : 'Risk Level'}</div>
                            {riskData?.riskScore ? <span className={'risk-level !text-button'} style={{ backgroundColor: chipColorStyle(riskData?.riskScore) }}>{riskData?.riskScore || '-'}</span> : '-'}
                        </div>
                    </div>
                </div>
                <div className='flex flex-col gap-[10px]'>

                    <p className='risk-content-title !text-subHeading-2 ' style={{ margin: 0 }}>{type === 'ISSUE' ? 'Impact of Issue' : 'Impact of Risk'}</p>
                    <p className='text-muted mt-1 break-words text-b5'>{riskData?.impactOfRisk}</p>
                </div>
                <div className='flex flex-col gap-[10px]'>

                    <p className='risk-content-title !text-subHeading-2 ' style={{ margin: 0 }}>By</p>
                    <div className='flex gap-3'>

                        <Avatar sx={{ width: 40, height: 40 }} src={riskData?.profilePic ? `data:${riskData?.profilePic?.contentType};base64,${riskData?.profilePic?.file}` : riskData?.name} alt={riskData?.user} />
                        <div className='w-[65%]'>
                            <div className='text-subMenu'style={{ width: '100%', color: 'hsl(var(--primary))' }}>{riskData?.user}</div>
                            <div className='flex gap-2'>
                                <div className='text-subMenu whitespace-nowrap text-[hsl(var(--Extreme))]' >{riskData?.role}</div>
                                <div className='text-subMenu whitespace-nowrap' style={{ width: '100%' }}>{formatDate(riskData?.createdAt)}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}
